import {
  aCreateOutlierRule,
  anOutlierRule,
  CreateOutlierRuleBuilderOperationMutation,
  mockCreateOutlierRuleBuilderOperationMutation,
} from '__generated__';
import { outlierRuleData } from 'mocks/queries/RuleBuilderQueryOperation.mocks';
import { delay, HttpResponse } from 'msw';

export const createOutlierRuleResponse: CreateOutlierRuleBuilderOperationMutation =
  {
    __typename: 'Mutation',
    createOutlierRule: aCreateOutlierRule({
      data: {
        ...anOutlierRule({ ...outlierRuleData }),
      },
    }),
  };

export const handlers = [
  mockCreateOutlierRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: createOutlierRuleResponse,
      });
    }
  ),
];
